import { useEffect, useState } from 'react';
import styles from './favorite.module.scss';
import { IconButton } from '@mui/material';
import { FavoriteSharedProps } from '../../interfaces/components';
import { useToast } from "../../helpers/hooks";
import { useNavigate } from "react-router-dom";
import { Skeleton } from '@mui/material';
import { images } from '../../constants/images';

const FavoriteShared = ({
    onPress,
    id, 
    liked = false,
    className,
    user,
    likedFetching,
    likePublication,
    dislikePublication,
    loading = false,
    redirect = "",
    setLoginRedirection
}: FavoriteSharedProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const [likedIcon, setLikedIcon] = useState<boolean>(liked);

    const handleChangeFavorite = (event: any, idItem: string) => {
        event.stopPropagation();
        if (!user) {
            toast("Debes iniciar sesion");
            setLoginRedirection(redirect);
            return navigate("/")
        };

        if(likedFetching === "loading"){
            return;
        }

        if (likedIcon) {
            dislikePublication(idItem);
        } else {
            likePublication(idItem);
        }

        setLikedIcon(!likedIcon);
        if(onPress) onPress(event);
    }

    useEffect(() => {
        setLikedIcon(liked);
    }, [liked]);
    
    useEffect(() => {
        if(likedFetching === 'failure'){
            toast("Ha ocurrido un error");
        }
        if(likedFetching === 'success'){
            setLikedIcon(liked);
        }
    }, [likedFetching]);

    return (
        <>
        {
            loading
            ? <Skeleton animation="wave" variant="circular" className={styles.skeleton} />
            : 
            <>
                <IconButton id="icon" className={className} onClick={(event: any) => handleChangeFavorite(event, id)}>
                    <img src={liked ? images.favorite : images.noFavorite} alt="Me gusta" title="Me gusta" id="iconFavorite" className={styles.favorite} />
                </IconButton>
            </>
        }
        </>
    );
};

export default FavoriteShared;